import React from 'react';
import PropTypes from 'prop-types';

const Pagination = ({
  currentPage,
  totalPages,
  onNavigate,
  resultsPerPage
}) => {
  const pagesArr = [];

  for (let i = 0; i < totalPages; i++) {
    pagesArr.push(
      <li key={i + 1}>
        <button
          type="button"
          className={i + 1 === currentPage ? 'pagination-btn current' : 'pagination-btn'}
          onClick={() => {
            onNavigate(i + 1);
          }}
        >
          {i + 1}
        </button>
      </li>
    );
  }

  const CurrentPage = () => {
    return (
      <>
        <li>
          <button
            type="button"
            className='pagination-btn current'
            onClick={() => {
              onNavigate(currentPage);
            }}
          >
            {currentPage}
          </button>
        </li>
      </>
    );
  };

  const InnerPagination = () => {
    return (
      <>
        {currentPage === totalPages && (
          <li>
            <button
              type="button"
              className='pagination-btn'
              onClick={() => {
                onNavigate(totalPages - 2);
              }}
            >
              {totalPages - 2}
            </button>
          </li>
        )}
        {((currentPage === 3) || (currentPage >= 3 && currentPage > totalPages - 2)) && (
          <li>
            <button
              type="button"
              className='pagination-btn'
              onClick={() => {
                onNavigate(currentPage - 1);
              }}
            >
              {currentPage - 1}
            </button>
          </li>
        )}
        <CurrentPage />
        {((currentPage >= totalPages - 2 && currentPage < totalPages - 1) || currentPage < 3) && (
          <li>
            <button
              type="button"
              className='pagination-btn'
              onClick={() => {
                onNavigate(currentPage + 1);
              }}
            >
              {currentPage + 1}
            </button>
          </li>
        )}
        {currentPage === 1 && (
          <li>
            <button
              type="button"
              className='pagination-btn'
              onClick={() => {
                onNavigate(currentPage + 2);
              }}
            >
              {currentPage + 2}
            </button>
          </li>
        )}
      </>
    );
  };

  const PaginationEllipsis = () => {
    return (
      <>
        {currentPage > 1 && (
          <li className="first-page">
            <button
              href={1}
              type="button"
              className='pagination-btn'
              onClick={() => {
                onNavigate(1);
              }}
            >
              {1}
            </button>
          </li>
        )}
        {currentPage > 3 && <li className="ellipsis">...</li>}
        <InnerPagination />
        {currentPage <= totalPages - 3 && <li className="ellipsis">...</li>}
        {currentPage < totalPages && (
          <li className="last-page">
            <button
              type="button"
              className='pagination-btn'
              onClick={() => {
                onNavigate(totalPages);
              }}
            >
              {totalPages}
            </button>
          </li>
        )}
      </>
    );
  };

  return (
    <div className="pagination">
      {resultsPerPage && (
        <>
          {pagesArr.length > 5 && (
            <button
              className="pagination-btn pagination--prev"
              role="button"
              type="button"
              aria-label="Previous page"
              onClick={() => {
                onNavigate(currentPage - 1);
              }}
              disabled={currentPage === 1}
            >
              <span className="cta-decorator-v2 cta-decorator-v2--internal">
                <svg viewBox="0 0 18 18">
                  <use xlinkHref="#link-arrow-right-icon"/>
                </svg>
              </span>
            </button>
          )}
          {totalPages > 1 && (
            <ul className="pagination-pages">
              {pagesArr.length <= 5 ? pagesArr : <PaginationEllipsis />}
            </ul>
          )}
          {totalPages > 5 && (
            <button
              className="pagination-btn pagination--next"
              role="button"
              type="button"
              aria-label="Next page"
              onClick={() => {
                onNavigate(currentPage + 1);
              }}
              disabled={currentPage === totalPages}
            >
              <span className="cta-decorator-v2 cta-decorator-v2--internal">
                <svg viewBox="0 0 18 18">
                  <use xlinkHref="#link-arrow-right-icon"/>
                </svg>
              </span>
            </button>
          )}
        </>
      )}
    </div>
  );
};

Pagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  onNavigate: PropTypes.func.isRequired
};

export default Pagination;
